import { httpClient } from '@/services/http/httpClient'
import type { PaginationResponse } from '@/types/paginationResponse'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

export type UserHttpResponse = {
  id: string
  name: string
  image?: string
}

type GetUsersHttpResponse = {
  users: UserHttpResponse[]
  paginate: PaginationResponse
}

type Params = {
  query: QueryParams
}

export type PublicUserResponse = {
  id: string
  name: string
  image?: string
}

type GetUsersResponse = {
  users: PublicUserResponse[]
  pagination: PaginationResponse
}

export async function getUsersForFilters({
  query,
}: Params): Promise<GetUsersResponse> {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get<GetUsersHttpResponse>(
    `/users/for-filters?${queryParams}`,
  )

  const { users: usersData = [], paginate } = data

  const users = usersData.map((user: UserHttpResponse) => ({
    id: user.id,
    name: user.name,
    image: user.image,
  }))

  const pagination = {
    page: paginate.page ?? 1,
    pages: paginate.pages ?? 0,
    total: paginate.total ?? 0,
  }

  return {
    users,
    pagination,
  }
}
